import React from "react";
import $ from "jquery";

function SurveyView(props) {
  $(".NumberValid").on("input", function() {
    var e = "۰".charCodeAt(0);
    this.value = this.value.replace(/[۰-۹]/g, function(t) {
      return t.charCodeAt(0) - e;
    });
    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    this.value = this.value.replace(/[٠-٩]/g, function(t) {
      return t.charCodeAt(0) - e;
    });
    this.value = this.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  });

  $(".valid-empty").on("blur", function() {
    var value_check = $(this).val();
    value_check = value_check.replace(/\s/g, "");
    if (value_check === null || value_check.length < 1) {
      $(this)
        .removeClass("is-valid")
        .addClass("is-invalid");
      $(this)
        .next(".invalid-feedback")
        .text("فیلد نمی تواند خالی باشد.");
      return false;
    }
    $(this)
      .removeClass("is-invalid")
      .addClass("is-valid");
  });
  function UpdateResponse(SurveyQuery_ID, SurveyQueryData_ID, Type) {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var SendData = false;
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("SurveyQuery_ID", SurveyQuery_ID);
      formdata.append("Type", Type);
      if (Type === "opt") {
        if (SurveyQueryData_ID !== null && SurveyQueryData_ID !== 0) {
          SendData = true;
          formdata.append("SurveyQueryData_ID", SurveyQueryData_ID);
        }
      }
      if (Type === "opt_describe") {
        let Describe = $("#describe_" + SurveyQuery_ID).val();
        if (Describe !== null && Describe !== "") {
          SendData = true;
          formdata.append("SurveyQueryData_Describe", Describe);
        }
      }
      if (Type === "TextArea") {
        let Describe = $("#TextArea_" + SurveyQuery_ID).val();
        if (Describe !== null && Describe !== "") {
          SendData = true;
          formdata.append("SurveyQueryData_Describe", Describe);
        }
      }
      if (SendData === true) {
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          `${process.env.REACT_APP_BASE_API_URL}/api/refahi/update-survey-response`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              console.log(result);
            }
          })
          .catch((error) => console.log("error", error));
      }
    }
  }
  function declineSurvey() {
    props.toggleSurvey();
  }
  function submitForm() {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var SendData = true;
      const myLists = props.surveyJson.data;
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("Survey_ID", props.surveyJson.query_id);
      myLists.forEach((myList) => {
        var res = null;
        if (myList.ID_Type === 1) {
          res = $('input[name="' + myList.ID + '"]:checked').val();
        } else if (myList.ID_Type === 4) {
          res = $("#TextArea_" + myList.ID).val();
        } else if (myList.ID_Type === 3) {
          res = $("#Select_" + myList.ID).val();
        }
        // console.log(res);
        if (myList.Need_Field === true) {
          if (res === "" || res === null || res === undefined) {
            SendData = false;
          }
        }
        formdata.append(myList.ID, res);
        if (myList.Need_Describe === true) {
          res = $("#describe_" + myList.ID).val();
          formdata.append(myList.ID + "_describe", res);
        }
      });

      if (SendData === true) {
        console.log(formdata);
        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };
        fetch(
          `${process.env.REACT_APP_BASE_API_URL}/api/refahi/submit-survey-response`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                props.toggleErrorMessage(myObject.message);
                props.toggleError();
                props.getUserRequest();
                props.toggleSurvey();
              } else {
                props.toggleErrorMessage(myObject.message);
                props.toggleError();
              }
            }
          })
          .catch((error) => console.log("error", error));
      } else {
        const errorMessage =
          "همکار گرامی لطفاً به تمامی سوالات ستاره دار پاسخ دهید.";
        props.toggleErrorMessage(errorMessage);
        props.toggleError();
      }
    }
    //     $('input[type="radio"]').each(function(index, obj){
    //         console.log(index, obj);
    //    });
  }
  const myLists = props.surveyJson.data;
  const listItems = myLists.map((myList) => (
    <div
      className={
        myList.Need_Field === true
          ? "valid-empty survey-item mb-2"
          : "survey-item mb-2"
      }
      key={myList.ID}
    >
      {myList.ID_Type === 5 ? (
        <p className="font-weight-bold m-0 title text-danger">{myList.Title}</p>
      ) : (
        <p className="font-weight-bold m-0 title">
          <span className="badge bg-danger rounded-pill">
            {myList.Query_index}
          </span>
          {myList.Title}
          {myList.Need_Field === true ? (
            <abbr className="text-danger">*</abbr>
          ) : null}{" "}
        </p>
      )}
      {/* {(myList.Title_Custom !== null) ? <small>{myList.Title_Custom}</small> : null} */}
      {myList.ID_Type === 1 ? (
        <div className="item-query">
          {myList.data.map((e) => (
            <div key={e.ID} className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name={myList.ID}
                id={e.ID}
                value={e.ID}
                onChange={() => UpdateResponse(myList.ID, e.ID, "opt")}
              ></input>
              <label className="form-check-label small" htmlFor={e.ID}>
                {e.Title}
              </label>
            </div>
          ))}
          {myList.Need_Describe === true ? (
            <div className="des">
              <input
                id={"describe_" + myList.ID}
                type="text"
                className="form-control form-control-sm"
                placeholder={myList.Title_Custom}
                onBlur={() => UpdateResponse(myList.ID, null, "opt_describe")}
              ></input>
            </div>
          ) : null}
        </div>
      ) : null}
      {myList.ID_Type === 3 ? (
        <div className="item-query">
          <select
            id={"Select_" + myList.ID}
            name={myList.ID}
            className="form-select form-select-lg text-center wp-input-text rounded-0"
            defaultValue=""
          >
            <option value="">انتخاب نمایید</option>
            {myList.data.map((e) => (
              <option value={e.ID}>{e.Title}</option>
            ))}
          </select>
        </div>
      ) : null}
      {myList.ID_Type === 4 ? (
        <div className="item-query">
          <textarea
            id={"TextArea_" + myList.ID}
            name={myList.ID}
            rows="3"
            className="form-control form-control-sm"
            onBlur={() => UpdateResponse(myList.ID, null, "TextArea")}
          ></textarea>
        </div>
      ) : null}
    </div>
  ));
  return (
    <div className="col-12">
      <div className="body-padding">
        <p className="wp-header text-center">{props.surveyJson.query_title}</p>
        <ul className="Array p-0 mb-2">
          {listItems.length === 0 ? (
            <li className="Array-item">
              <div className="title">سوالی در این پرسشنامه وجود ندارد.</div>
            </li>
          ) : (
            listItems
          )}
        </ul>
        <div className="col-12 text-left">
          <button
            className="btn btn-danger rounded-0 ml-2"
            onClick={declineSurvey}
          >
            انصراف
          </button>
          <button
            id="SubmitForm"
            className="btn dina-btn-blue rounded-0"
            onClick={submitForm}
          >
            ثبت نظر
          </button>
        </div>
      </div>
    </div>
  );
}

export default SurveyView;
